import PropTypes from 'prop-types';

export const MaxPaxProps = PropTypes.shape({
    maxPassengers: PropTypes.number.isRequired,
    maxChildrenPerAdult: PropTypes.number.isRequired,
    maxInfantsPerAdult: PropTypes.number.isRequired,
});

export const MaxPaxPropsDefaults = {
    maxPassengers: 9,
    maxChildrenPerAdult: 2,
    maxInfantsPerAdult: 1,
};
